import React from 'react'
import {
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
} from '@mui/material'

class ObjectCreatedInfo extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            item: this.props.item,
        }
    }

    render() {
        const kedo = this.props.kedo
        const item = this.state.item

        return (
            <TableContainer component={Paper}>
                <Table
                    size="small"
                    sx={{
                        '& tbody tr:nth-of-type(odd)': {
                            backgroundColor: (theme) =>
                                theme.palette.action.hover,
                        },
                    }}
                >
                    <TableBody
                        sx={{
                            '& th': {
                                textAlign: 'left',
                                fontWeight: 'bold',
                            },
                        }}
                    >
                        <TableRow>
                            <TableCell component="th">{kedo.t('Id')}</TableCell>
                            <TableCell>{item.id}</TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell component="th">
                                {kedo.t('Name')}
                            </TableCell>
                            <TableCell>{item.name}</TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell component="th">
                                {kedo.t('Uuid')}
                            </TableCell>
                            <TableCell>{item.uuid}</TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell component="th">
                                {kedo.t('Created by')}
                            </TableCell>
                            <TableCell>
                                {item.created_by
                                    ? item.created_by.username
                                    : null}
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell component="th">
                                {kedo.t('Created at')}
                            </TableCell>
                            <TableCell>
                                {item.created_at
                                    ? kedo.utils().dateFormat(item.created_at)
                                    : null}
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell component="th">
                                {kedo.t('Modified by')}
                            </TableCell>
                            <TableCell>
                                {item.modified_by
                                    ? item.modified_by.username
                                    : null}
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell component="th">
                                {kedo.t('Modified at')}
                            </TableCell>
                            <TableCell>
                                {item.modified_at
                                    ? kedo.utils().dateFormat(item.modified_at)
                                    : null}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}

export default ObjectCreatedInfo
